import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

function Button({
  title,
  type,
  className,
  disabled,
  loading,
  handleClick,
  color,
}) {
  const [gcolor, setGcolor] = useState([]);
  useEffect(() => {
    const colorArr = color?.split(",") || [];
    let colors = [];
    colorArr.forEach((item, index, array) => {
      if (index !== array.length - 1) {
        colors.push("#" + item);
      }
    });
    setGcolor(colors.toString());
  }, []);
  return (
    <div>
      <button
        type={type}
        className={className}
        disabled={disabled || loading}
        onClick={handleClick}
        style={{
          background: `linear-gradient(${gcolor})`,
          border: 0,
          padding: "10px 30px",
          color: "white",
          borderRadius: 10,
        }}
      >
        {title}
      </button>
    </div>
  );
}

Button.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  handleClick: PropTypes.func,
  color: PropTypes.string,
};

Button.defaultProps = {
  title: "Button",
  type: "submit",
  className: "btn btn-primary",
  disabled: false,
  loading: false,
  handleClick: undefined,
  color: "",
};

export default Button;
